<template>
  <div class="quill-wrap">

  <el-divider>富文本 编辑器</el-divider>
    <quill-editor
      v-model="content"
      ref="myQuillEditor"
      :options="quillOption"
    >
    </quill-editor>
     <el-button type="danger" @click="cont">危险按钮</el-button>
	 <div>

    <el-divider>上传视频</el-divider>
	        <p class="type_title">
	            <span>视频介绍</span>
	        </p>
	        <div class="pic_img">
	            <div class="pic_img_box">
	                <el-upload class="avatar-uploader"
	                           action="http://pc.zyjlfwpt.com/api.php/Upload/uploadcordssp"
	                           v-bind:data="{FoldPath:'上传目录',SecretKey:'安全验证'}"
	                           v-bind:on-progress="uploadVideoProcess"
	                           v-bind:on-success="handleVideoSuccess"
	                           v-bind:before-upload="beforeUploadVideo"
	                           v-bind:show-file-list="false">
	                    <video v-if="videoForm.showVideoPath !='' && !videoFlag"
	                           v-bind:src="videoForm.showVideoPath"
	                           class="avatar video-avatar"
	                           controls="controls">
	                        您的浏览器不支持视频播放
	                    </video>
	                    <i v-else-if="videoForm.showVideoPath =='' && !videoFlag"
	                       class="el-icon-plus avatar-uploader-icon"></i>
	                    <el-progress v-if="videoFlag == true"
                       type="circle"
                       v-bind:percentage="videoUploadPercent"
                       style="margin-top:7px;"></el-progress>
	                </el-upload>
	            </div>
	        </div>
	    </div>
	    <p class="Upload_pictures">
	        <span></span>
	        <span>最多可以上传1个视频，建议大小50M，推荐格式mp4</span>
	    </p>

      <el-divider>多图上传</el-divider>




      <el-upload
        action="http://pc.zyjlfwpt.com/api.php/Upload/uploadcords"
        list-type="picture-card"
        :file-list="photoList"
        :before-upload="photoBeforeUpload"
        :on-preview="photoPreview"
        :on-remove="photoRemove"
        :on-success="photoSuccess">
        <i class="el-icon-plus"></i>
      </el-upload>
      <el-dialog :visible.sync="dialogVisible" append-to-body>
        <img width="100%" :src="dialogImageUrl" alt="" >
      </el-dialog>




  </div>
</template>
<script>

  import { quillEditor } from 'vue-quill-editor'
  import quillConfig from '../../static/js/quill-config.js'

  // import VueQuillEditor from 'vue-quill-editor';


export default{
  data(){
    return {
       content: '',
       quillOption: quillConfig,
	   // 上传视频
	   videoFlag: false,
		  //是否显示进度条
		  videoUploadPercent: "",
		  //进度条的进度，
		  isShowUploadVideo: false,
		  //显示上传按钮
		  videoForm: {
			  showVideoPath: ''
		  },

      //  多图
      photoList: [],
      dialogImageUrl: '',
      dialogVisible: false,
    }
  },
  mounted () {
    var that = this;
    that.$api.post("/Upload/uploadcorda",{}).then(res => {
      console.log(res);
    });
  },
  methods:{
      // 多图上传
      photoBeforeUpload:function(file) {
        const isJPG = file.type === "image/jpeg" || file.type === "image/png";
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isJPG) {
    　　　　　this.$message.error("上传图片只能是 JPG 和 Png 格式!");
    　　　　　return false;
    　　　}
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      },
      photoRemove:function(file, fileList) {
        this.upload(fileList);
      },
      photoPreview:function(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      photoSuccess:function(response, file, fileList){
        this.upload(fileList);
      },
      upload:function(fileList){
        let that   = this;
        // let userid = this.$cookie.get('userid');
        console.log(fileList);
        var picarr = [];
        fileList.forEach((item, index) => {
          console.log(item.response)
          var mycars = new Array();
          mycars['name'] = index;
          if(item.response){
            mycars['url']  = item.response.path;
          }else{
            mycars['url']  = item.path;
          }
          picarr.push(mycars);
        })
        console.log(picarr);

      },
      // 多图上传 结束

















    cont(){
      console.log(this.content);
      console.log(this.$refs.myQuillEditor.value);
    },



    //上传前回调
    beforeUploadVideo(file) {
        var fileSize = file.size / 1024 / 1024 < 100;
        if (['video/mp4', 'video/ogg', 'video/flv', 'video/avi', 'video/wmv', 'video/rmvb', 'video/mov'].indexOf(file.type) == -1) {
           this.$message.error("请上传正确的视频格式");
            return false;
        }
        if (!fileSize) {
            this.$message.error("视频大小不能超过100MB");
            return false;
        }
        this.isShowUploadVideo = false;
    },
    //进度条
    uploadVideoProcess(event, file, fileList) {
        this.videoFlag = true;
        this.videoUploadPercent = file.percentage.toFixed(0) * 1;
    },
    //上传成功回调
    handleVideoSuccess(res, file) {
        this.isShowUploadVideo = true;
        this.videoFlag = false;
        this.videoUploadPercent = 0;

        //前台上传地址
        //if (file.status == 'success' ) {
        //    this.videoForm.showVideoPath = file.url;
        //} else {
        //     layer.msg("上传失败，请重新上传");
        //}

        //后台上传地址
        if (res.code == 0) {
            this.videoForm.showVideoPath = res.data;
        } else {
            // layer.msg(res.Message);
            console.log(res);
        }
    }




  }
 }
</script>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue